import React from 'react';

import { Link } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

import './styles.scss';

const EmptyStateCard = ({
  icon,
  iconAlt,
  title,
  description,
  learnMoreLabel,
  learnMoreTo = '/',
  actionsClassName = '',
  children,
}) => (
  <Box className="olcEmptyStateCard">
    <Box className="olcEmptyStateContent">
      <img className="olcEmptyStateIcon" src={icon} alt={iconAlt} />
      <Typography className="olcEmptyStateTitle">{title}</Typography>
      <Typography className="olcEmptyStateDescription">{description}</Typography>
      {learnMoreLabel && (
        <Link className="olcEmptyStateLearnMore" to={learnMoreTo}>
          {learnMoreLabel}
        </Link>
      )}
      {children && (
        <Box className={`olcEmptyStateActions ${actionsClassName}`.trim()}>{children}</Box>
      )}
    </Box>
  </Box>
);

export default EmptyStateCard;
